import React, { useEffect, useState } from 'react';
import AdminLayout from './AdminLayout';
import { api } from '../lib/api';
import { useToast } from './useToast';

export default function AdminSettings() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const [toast, showToast] = useToast();

  useEffect(() => {
    api.getSettings().then(setForm);
  }, []);

  function update(field, value) {
    setForm(f => ({ ...f, [field]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    try {
      const updated = await api.updateSettings({
        ...form,
        deliveryFee: Number(form.deliveryFee) || 0,
        freeDeliveryAbove: Number(form.freeDeliveryAbove) || 0,
      });
      setForm(updated);
      showToast('Settings updated');
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setSaving(false);
    }
  }

  return (
    <AdminLayout title="Pricing & Delivery Settings">
      {!form ? (
        <p style={{ fontFamily: 'var(--font-sans)', color: 'var(--text-mid)' }}>Loading…</p>
      ) : (
        <form onSubmit={handleSubmit} className="admin-form">
          <div className="admin-form-group">
            <label>Brand Name</label>
            <input type="text" value={form.brandName} onChange={e => update('brandName', e.target.value)} />
          </div>
          <div className="admin-form-group">
            <label>Tagline</label>
            <input type="text" value={form.tagline} onChange={e => update('tagline', e.target.value)} />
          </div>
          <div className="admin-form-group">
            <label>Slogan (shown above the cake gallery)</label>
            <input type="text" value={form.slogan} onChange={e => update('slogan', e.target.value)} />
          </div>
          <div className="admin-form-group">
            <label>Location</label>
            <input type="text" value={form.location} onChange={e => update('location', e.target.value)} />
          </div>

          <div className="admin-form-row">
            <div className="admin-form-group">
              <label>WhatsApp Number (digits only, country code)</label>
              <input
                type="text"
                placeholder="923052609077"
                value={form.whatsapp}
                onChange={e => update('whatsapp', e.target.value)}
              />
            </div>
            <div className="admin-form-group">
              <label>WhatsApp Number (display)</label>
              <input
                type="text"
                placeholder="+92 305 2609077"
                value={form.whatsappDisplay}
                onChange={e => update('whatsappDisplay', e.target.value)}
              />
            </div>
          </div>
          <p className="admin-hint" style={{ marginTop: -10, marginBottom: 18 }}>
            Every confirmed order — from the Order page, the cake detail page, and the floating
            WhatsApp button — is sent to this number.
          </p>

          <div className="admin-form-row">
            <div className="admin-form-group">
              <label>Instagram URL</label>
              <input type="text" value={form.instagram} onChange={e => update('instagram', e.target.value)} />
            </div>
            <div className="admin-form-group">
              <label>Facebook URL</label>
              <input type="text" value={form.facebook} onChange={e => update('facebook', e.target.value)} />
            </div>
          </div>

          <div className="admin-form-row">
            <div className="admin-form-group">
              <label>Delivery Charge (PKR)</label>
              <input
                type="number"
                min="0"
                value={form.deliveryFee}
                onChange={e => update('deliveryFee', e.target.value)}
              />
            </div>
            <div className="admin-form-group">
              <label>Free Delivery Above (PKR, 0 = disabled)</label>
              <input
                type="number"
                min="0"
                value={form.freeDeliveryAbove}
                onChange={e => update('freeDeliveryAbove', e.target.value)}
              />
            </div>
          </div>

          <button type="submit" className="admin-btn admin-btn-primary" disabled={saving}>
            {saving ? 'Saving…' : 'Save Settings'}
          </button>
        </form>
      )}
      {toast && <div className={`admin-toast ${toast.type === 'error' ? 'error' : ''}`}>{toast.message}</div>}
    </AdminLayout>
  );
}
